import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBunqComponent } from './simple-icons-bunq.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBunqComponent ],
    exports:      [ SimpleIconsBunqComponent ],
    bootstrap:    []
})
export class SimpleIconsBunqModule {}
